module.exports = __webpack_public_path__ + "img/95fr.4a75e1fb.png";